<div class="page">
  <div class="content">
     @if (logoUrl()) {
      <div class="logo" [style.background-image]="logoUrl()"></div>
    }

    <h5>{{ 'SETTINGS.SELECT_LANGUAGE' | translate }}</h5>

    <div class="languages">
      @for (lang of languages(); track lang.key) {
        <button class="btn" type="button" [attr.data-testid]="'select-language-' + lang.key" (click)="selectLanguage(lang.key)">{{ lang.label | translate }}</button>
      }
    </div>
  </div>
 
</div>
